// Finar Ö4 — tablo satırının ilk hücresi gerçek bağlantı: klavyeyle odaklanır, Enter ile
// açılır, orta tık / Cmd+tık yeni sekmede açar. Satır tıklaması (FilteredTable onRowClick)
// aynen kalır; bağlantı tıklaması satıra kabarmaz (çift gezinme yok).
import { type ReactNode } from "react";
import { Link } from "react-router-dom";

export function RowLink({ to, children }: { to: string; children: ReactNode }): JSX.Element {
  return (
    <Link
      to={to}
      onClick={(e) => e.stopPropagation()}
      style={{ fontWeight: 500, color: "inherit", textDecoration: "none" }}
      className="hover:underline focus-visible:underline"
    >
      {children}
    </Link>
  );
}
